import { FC } from 'react';
import { Breadcrumb, MenuCardList } from '../../components/_Molecules';
import { IPreviousRoute } from '../../components/_Molecules/Breadcrumb';
import { MACHINE_EXCHANGE } from '../../constants/menu.constants';
import { MENU_ROUTES, ROUTES } from '../../constants/routes.constants';

const MachinePricesManagement: FC = () => {
  const previousRoutesList: IPreviousRoute[] = [
    {
      routeName: 'Menu principal',
      routePath: ROUTES.MAIN_MENU
    },
    {
      routeName: 'Gestão de ativos',
      routePath: MENU_ROUTES.ASSET_MANAGEMENT
    }
  ];

  return (
    <>
      <Breadcrumb
        previousRoutes={previousRoutesList}
        currentRouteName="Troca / Devolução"
      />
      <MenuCardList columns="TWO" menuCardList={MACHINE_EXCHANGE} />
    </>
  );
};

export default MachinePricesManagement;
